import { FOREIGN_CHARACTERS } from '../validators/auth';


export const EMAIL_HINT = "Value can contain letters, digits, characters !#$%&'*+-/=?^_`{|}~, double-quote characters may be used to surround strings, character . provided that it is not the first or last character and it will not come one after the other";
export const FOREIGN_CHARACTERS_HINT = 'Only ASCII characters are allowed, a-A-z-Z0-9, please check if your keyboard is set to English';
export const PASSWORD_MINIMUM_HINT = 'At least 7 characters is required';

export function handlePasswordChange(name, value) {

    let error = {};

    if (name === 'password' || name === 'repeat_password' || name === 'pass') {

        if (name === 'password' && value.length < 7) {
            error[name] = PASSWORD_MINIMUM_HINT;
        }

        if (FOREIGN_CHARACTERS.test(value)) {
            value = value.replace(FOREIGN_CHARACTERS, '');
            error[name] = FOREIGN_CHARACTERS_HINT;
        }
    }

    return {
        value: value,
        error: error
    }
}